export class DipCustomerIdentity {
  firstName: string;
  lastName: string;
  birthDate: string;
  postalCode: string;
  email: string;

  constructor(firstName: string, lastName: string, birthDate: string, postalCode: string, email: string) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.birthDate = birthDate;
    this.postalCode = postalCode;
    this.email = email;
  }
}
